module.exports = __webpack_public_path__ + "media/images/top/top_content_hr-4fc65a3a8563d2e37659481f049741d0.png";